__webpack_require__.p = "https://exod-pre.sms-group.com/";